var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen",attrs:{"id":"app"}},[_c('TheHeader',{attrs:{"current-page":_vm.currentPage},on:{"navigate":_vm.handleNavigate}}),_c('keep-alive',[_c(_vm.currentPageComponent,_vm._b({tag:"component"},'component',_vm.currentPageProps,false))],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }